/* eslint-disable  */
import React from 'react'
import DeviceEmulator from 'react-device-emulator'
import 'react-device-emulator/lib/styles/style.css'
import BottomBar from '../BottomBar'
import ReactCardFlip from 'react-card-flip'
import StoryContentView from './ContentView/StoryContentView'
import McqContentView from './ContentView/McqContentView'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import FlipToStoryView from './ContentView/FlipToStoryView'
import OnlyCoverView from './ContentView/OnlyCoverView'
import InAppBrowserView from './ContentView/InAppBrowserView'
import SlideShowView from './ContentView/SlideShowView'

import PollContentView from './ContentView/PollContentView'
import ShortByteView from './ContentView/ShortByteView'

class Preview extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			dispShowMore: false,
			explanationModal: false,
			isFlipped: false,
		}
	}

	handleClick = e => {
		e.preventDefault()
		this.setState(prevState => ({ isFlipped: !prevState.isFlipped }))
	}

	coverStoryContentView = () => {
		const { data, contentSelectedLangVal } = this.props
		const {
			coverStoryType,
			flipToStoryDetails,
			onlyCoverDetails,
			inAppBrowserDetails,
		} = data.contentMetaInfo.coverStoryDetails
		switch (coverStoryType) {
			case 'FlipToStory':
				return (
					<FlipToStoryView
						preview={true}
						content={data}
						changeCardTextColor={() => {
							this.setState({ enableCardTextColor: !this.state.enableCardTextColor })
						}}
						coverStoryTitle={flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`]}
						coverStoryCardDescription={
							flipToStoryDetails[`coverStoryCardDescription_${contentSelectedLangVal}`]
						}
						contentSelectedLangVal={contentSelectedLangVal}
						contentNewLinkDetails={flipToStoryDetails?.contentNewLinkDetails}
					/>
				)
			case 'OnlyCover':
				return (
					<OnlyCoverView
						preview={true}
						content={data}
						onlycoverDetails={data.contentMetaInfo.coverStoryDetails.onlyCoverDetails}
						coverStoryTitle={onlyCoverDetails[`coverStoryTitle_${contentSelectedLangVal}`]}
						coverStoryCardDescription={
							onlyCoverDetails[`coverStoryCardDescription_${contentSelectedLangVal}`]
						}
						coverStoryVideoURL={onlyCoverDetails.coverStoryVideoURL}
						contentNewLinkDetails={onlyCoverDetails?.contentNewLinkDetails}
					/>
				)
			case 'InAppBrowser':
				return (
					<InAppBrowserView
						preview={true}
						content={data}
						coverStoryTitle={inAppBrowserDetails[`coverStoryTitle_${contentSelectedLangVal}`]}
						contentNewLinkDetails={inAppBrowserDetails?.contentNewLinkDetails}
					/>
				)
			default:
				return null
		}
	}

	renderContent = contentType => {
		const { data, contentSelectedLangVal } = this.props
		switch (contentType) {
			case 'ShortByte':
				return (
					<ShortByteView
						preview={true}
						content={data}
						shortByteTemplateType={data.contentMetaInfo.storyDetails.shortByteTemplateType ? data.contentMetaInfo.storyDetails.shortByteTemplateType : 'Small'}
						contentType={contentType}
						title={data.contentMetaInfo.storyDetails[`storyTitle_${contentSelectedLangVal}`]}
						cardDescription={
							data.contentMetaInfo.storyDetails[`storyCardDescription_${contentSelectedLangVal}`]
						}
						cardImages={
							data.contentMetaInfo.storyDetails.storyCardOriginalImages
								? data.contentMetaInfo.storyDetails.storyCardOriginalImages
								: data.contentMetaInfo.storyDetails.storyCardImages
						}
						contentLinkDetails={data.contentMetaInfo.storyDetails.contentLinkDetails}
						contentNewLinkDetails={data.contentMetaInfo.storyDetails.contentNewLinkDetails}
						coverStoryVideoURL={data.contentMetaInfo.storyDetails.coverStoryVideoURL}
					/>
				)
			case 'Story':
				return (
					<StoryContentView
						preview={true}
						content={data}
						contentType={contentType}
						title={data.contentMetaInfo.storyDetails[`storyTitle_${contentSelectedLangVal}`]}
						cardDescription={
							data.contentMetaInfo.storyDetails[`storyCardDescription_${contentSelectedLangVal}`]
						}
						cardImages={
							data.contentMetaInfo.storyDetails.storyCardOriginalImages
								? data.contentMetaInfo.storyDetails.storyCardOriginalImages
								: data.contentMetaInfo.storyDetails.storyCardImages
						}
						contentLinkDetails={data.contentMetaInfo.storyDetails.contentLinkDetails}
						contentNewLinkDetails={data.contentMetaInfo.storyDetails.contentNewLinkDetails}
						coverStoryVideoURL={data.contentMetaInfo.storyDetails.coverStoryVideoURL}
					/>
				)
			case 'CoverStory':
				return this.coverStoryContentView()
			case 'Mcq':
				return (
					<McqContentView
						preview={true}
						content={data}
						mcqTitle={data.contentMetaInfo.mcqDetails[`mcqTitle_${contentSelectedLangVal}`]}
						explanationCardTitle={
							data.contentMetaInfo.mcqDetails[`explanationCardTitle_${contentSelectedLangVal}`]
						}
						answerExplanation={
							data.contentMetaInfo.mcqDetails[`answerExplanation_${contentSelectedLangVal}`]
						}
						contentVisibleLang={contentSelectedLangVal}
						contentNewLinkDetails={data.contentMetaInfo.mcqDetails.contentNewLinkDetails}
					/>
				)

			case 'Poll':
				return (
					<PollContentView
						preview={true}
						content={data}
						pollTitle={data.contentMetaInfo.pollDetails[`pollTitle_${contentSelectedLangVal}`]}
						pollDescription={
							data.contentMetaInfo.pollDetails[`pollDescription_${contentSelectedLangVal}`]
						}
						contentVisibleLang={contentSelectedLangVal}
						contentNewLinkDetails={data.contentMetaInfo.pollDetails.contentNewLinkDetails}
					/>
				)
			case 'SlideShow':
				return (
					<SlideShowView
						isPausedVideo={this.state.isPausedVideo}
						content={data}
						preview={true}
						contentVisibleLang={contentSelectedLangVal}
					/>
				)
			default:
				return null
		}
	}

	render() {
		const { data, type } = this.props
		const height = data.contentType === 'Story' ? '90%' : '100%'
		return (
			<div
				style={{
					position: 'relative',
					height: heightPercentageToDP(height),
				}}
			>
				{this.renderContent(data.contentType)}
				<BottomBar

					data={this.props.data}
					selectedContributor={this.props.selectedContributor}
					createAs={this.props.createAs}
					type={type}
				/>
			</div>
		)
	}
}

export default Preview
